// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:11:25

export default {
  "id": "pixel-path",
  "slug": "pixel-path",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3ffc5c0944f54f06afb212ca7d80bb00-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3ffc5c0944f54f06afb212ca7d80bb00/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pixel Path",
      "description": "Pixel Path is a platformer with a non—standard plot.?\nGet to the portal at the end of the level to win, but it's not as easy as it might seem... The floor may collapse, the spikes will move on you, and your character will grow to huge sizes. One wrong step and the game is over.❌\nYou will have to keep your sanity, expect surprises, show a good reaction and most importantly: do not get angry.?\nThe game also has a table of the best players who completed all levels faster than the rest. \n",
      "instructions": "The goal is simple: get to the portal at the end of the level, the path to it is not as easy as it may seem...\n\nMovement - arrow buttons or W A S D. \nOn computer: view rewarded ads when they are available - G. Exit to menu - ESC.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "arcade",
        "pixel"
      ]
    },
    "zh-CN": {
      "title": "像素路径",
      "description": "像素路径是一款具有非标准剧情的平台游戏。\n到达关卡末尾的传送门以获胜，但这并不像看起来那么简单……地板可能会塌陷，尖刺会移动，你的角色会变得巨大。一步走错，游戏就结束了。❌\n你将需要保持理智，预料到惊喜，展现出良好的反应，最重要的是：不要生气。\n游戏还有一个记录最佳玩家的排行榜，他们完成所有关卡的速度比其他人都要快。",
      "instructions": "目标很简单：到达关卡末尾的传送门，通往它的路径并不像看起来那么容易...\n\n移动 - 箭头键或W A S D。\n在电脑上：当有可用时观看奖励广告 - G。退出到菜单 - ESC。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "街机",
        "像素"
      ]
    },
    "zh-TW": {
      "title": "像素道路",
      "description": "Pixel Path 是一款具有非標準劇情的平台遊戲？\n通過達到等級末端的通道以獲勝，但這並不像看起來那麼容易... 樓板可能會塌陷，針刺會移動，而你的角色會變得巨大。一步錯誤，遊戲就結束了。❌\n你必須保持理智，預期驚喜，展現出色的反應，最重要的是：不要生氣。？\n遊戲還有一個最佳玩家榜，記錄了完成所有等級比其他人更快的玩家。",
      "instructions": "目標簡單：達到等級結束的門，通往那裡的路並不像看起來那麼容易……\n\n移動 - 順箭頭按鈕或 W A S D。\n在電腦上：當有可用的時候觀看獎勵型廣告 - G。回到主選單 - ESC。",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "1人遊玩",
        "街機",
        "像素"
      ]
    },
    "zh-HK": {
      "title": "像素小徑",
      "description": "像素路徑是一款非標準劇情的平台遊戲。?\n達到關卡結尾的傳送門以獲勝，但這並不像看起來那麼容易... 樓板可能會塌陷，針刺會移動，而你的角色會變得巨大。一個錯誤的步伐遊戲就結束了。❌\n你必須保持冷靜，預期驚喜，展現良好的反應，最重要的是：不要生氣。?\n遊戲還有一個最佳玩家榜單，那些完成所有關卡比其他人更快的玩家將會出現在榜單上。",
      "instructions": "目標簡單：到達關卡尾端的傳送門，通往那裡的路並不像看起來那麼容易……\n\n移動 - 選擇箭頭按鈕或 W A S D。\n電腦版：當有廣告可供觀看時，點擊 G 觀看獎勵廣告。返回主選單 - ESC。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "街機",
        "像素"
      ]
    },
    "ja": {
      "title": "ピクセルパス",
      "description": "ピクセルパスは標準外のストーリーのプラットフォームゲームです。\nレベルの最後にポータルに到達して勝利するが、思った以上に簡単ではありません... 床が崩れ落ち、棘が動き、キャラクターが巨大に成長します。一歩間違えばゲームは終了です。❌\nあなたは自分の精神を保ち、驚きに対応し、良い反応を見せなければなりません。そしてもっとも大切なのは：怒らないことです。\nまた、このゲームには、他のプレイヤーより早くすべてのレベルをクリアしたベストプレイヤーのリストがあります。",
      "instructions": "ゴールはシンプルです：レベルの最後にポータルに到達する、それにたどる道は思ったよりも簡単ではありません...\n\n移動 - 項目ボタンまたはWASD。\nコンピューター：利用可能な際に報酬広告を表示 - G。メニューに戻る - ESC。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "ピクセル"
      ]
    },
    "ko": {
      "title": "픽셀 패스",
      "description": "픽셀 패스는 비표준적인 스토리를 가진 플랫폼 게임입니다.\n레벨의 끝에 포털에 도달하여 승리하세요, 하지만 생각보다 쉽지 않습니다... 바닥이 무너질 수 있고, 지렛대가 움직일 수 있으며, 캐릭터가 거대한 크기로 커질 수 있습니다. 오류한 걸음으로 게임이 끝납니다.❌\n신경을 차리고 예상치 못한 일이 일어나기를 기대하며, 좋은 반응을 보여주고 가장 중요한 것은 분노하지 마세요.\n이 게임에는 모든 레벨을 가장 빠르게 완료한 최고의 플레이어 테이블도 있습니다.",
      "instructions": "목표는 간단합니다: 레벨 끝에 있는 포털에 도달하는 것입니다. 이 경로는 생각보다 쉽지 않습니다...\n\n이동 - 화살표 키나 W A S D.\n컴퓨터에서: 보상형 광고가 있을 때 광고 볼 때 - G. 메뉴로 이동 - ESC.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "픽셀"
      ]
    },
    "fr": {
      "title": "Chemin de pixel",
      "description": "Pixel Path est un plate-formiste avec un scénario non standard.\nPour gagner, atteignez le portail à la fin du niveau, mais ce n'est pas aussi simple qu'il pourrait paraître... Le sol peut s'effondrer, les piques bougeront, et votre personnage prendra de grandes tailles. Un pas en faux et le jeu est terminé.❌\nVous devrez conserver votre calme, vous attendre à des surprises, montrer une bonne réaction et surtout : ne perdez pas votre calme.?\nLe jeu comprend également un tableau des meilleurs joueurs qui ont terminé tous les niveaux plus rapidement que les autres.",
      "instructions": "L'objectif est simple : atteindre le portail à la fin du niveau, le chemin pour y accéder n'est pas aussi facile qu'il peut paraître...\n\nMouvement - touches flèches ou W A S D.\nSur ordinateur : visionner les publicités récompensées lorsqu'elles sont disponibles - G. Quitter pour le menu - ESC.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "pixel"
      ]
    }
  }
};
